import store from '@/store'

export const storeReset = (to, from) => {
  if (to.name !== from.name) {
    store.commit('setFilters', {})
    store.commit('setCurrentPage', 1)
    store.commit('setIsDrawerOpen', false)
    store.commit('setTotalPages', 1)
  }
}
